import { render } from "./product_details.vue?vue&type=template&id=a6de47e4"
import script from "./product_details.vue?vue&type=script&lang=js"
export * from "./product_details.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/elsaygh_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__